<template>
	<div class="c-profile-index">
		<loading-dots v-if="loading"></loading-dots>
		<template v-if="!loading">
			<div class="h-text--center h-margin-bottom--double h-cf" v-if="credits.length">
				<h2 class="h-gamma">Creatives</h2>
				<div class="h-flex">
					<profile-block :item="item" v-for="(item, index) in credits" :key="item.id"></profile-block>
				</div>
			</div>

			<div class="h-text--center h-cf h-margin-bottom--double" v-if="yaa.length">
				<h2 class="h-gamma">Young Associate Artists</h2>
				<div class="h-flex">
					<profile-block :item="item" v-for="(item, index) in yaa" :key="item.id"></profile-block>
				</div>
			</div>

			<div class="h-text--center h-cf h-margin-bottom--double" v-if="cast.length">
				<h2 class="h-gamma" v-text="castTitle"></h2>
				<div class="h-flex">
					<profile-block :item="item" v-for="(item, index) in cast" :key="item.id"></profile-block>
				</div>
			</div>

			<div class="h-text--center h-cf h-margin-bottom--double" v-if="tourManagement.length">
				<h2 class="h-gamma">Tour Management</h2>
				<div class="h-flex">
					<profile-block :item="item" v-for="(item, index) in tourManagement" :key="item.id"></profile-block>
				</div>
			</div>

			<div class="h-text--center h-cf h-margin-bottom--double" v-if="crewProfiles.length">
				<h2 class="h-gamma">Technical Staff</h2>
				<div class="h-flex">
					<profile-block :item="item" v-for="(item, index) in crewProfiles" :key="item.id"></profile-block>
				</div>
			</div>

			<div class="h-text--center h-cf" v-if="crew.length">
				<div class="h-margin-left--auto h-margin-right--auto h-two-thirds h-tablet-one-whole" v-html="crew">
				</div>
			</div>


		</template>
	</div>
</template>


<script>
	import profileBlock from './profile-block.vue';
	import loadingDots from './loading-dots.vue';
	import axios from 'axios';

	export default {
		name: 'profiles-index',
		data() {
			return {
				loading    		: true,
				credits    		: [],
				tourManagement  : [],
				cast       		: [],
				castTitle  		: 'Cast',
				yaa        		: [],
				crew       		: '',
				crewProfiles	: []
			}
		},
		components : {
			profileBlock,
			loadingDots
		},
		mounted() {
			if (this.active) {
				this.getItems();
			}
		},
		props: {
			id: {
				type: Number
			},
			active: {
				type: Boolean
			}
		},
		methods: {
			getItems() {
				var url = '/api/profiles/' + this.id + '.json'

				axios.get(url, { crossdomain: true })
				.then((response) => {

						this.cast       = response.data.cast;
						this.credits    = response.data.credits;
						this.tourManagement    = response.data.tourManagement;
						this.crew       = response.data.crew;
						this.yaa        = response.data.yaa;
						this.crewProfiles = response.data.crewProfiles;
						this.loading    = false;
				})
			},
		},
		watch: {
			active: function(newVal, oldVal) {
				if (!this.credits.length || !this.cast.length || !this.tourManagement.length) {
					this.getItems();
				}
			}
		}
	};
</script>



// WEBPACK FOOTER //
// profile-index.vue?5c336804